import React from 'react';
import { motion } from 'framer-motion';
import { TOPICS } from '../../data/content';

// Vary size for cloud effect
const sizeFor = (i) => {
  const mod = i % 5;
  if (mod === 0) return 'text-2xl md:text-3xl';
  if (mod === 1) return 'text-base md:text-lg';
  if (mod === 2) return 'text-xl md:text-2xl';
  if (mod === 3) return 'text-sm md:text-base';
  return 'text-lg md:text-xl';
};

export default function TopicsCloud() {
  return (
    <section id="topics" data-testid="topics-cloud" className="relative py-24 md:py-32 border-y-2 border-white/10 bg-black/20 halftone halftone-soft">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-12 text-center">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-teal mb-4">
            — Topics Covered —
          </p>
          <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter">
            From Prompts to<br /><span className="text-teal">Production Pipelines.</span>
          </h2>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 max-w-5xl mx-auto">
          {TOPICS.map((t, i) => (
            <motion.span
              key={t}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: Math.min(i * 0.02, 0.6), duration: 0.4 }}
              className={`font-display font-semibold tracking-tight px-5 py-2 rounded-full border border-white/10 bg-white/[0.02] text-white/80 hover:border-teal hover:text-teal transition-colors cursor-default ${sizeFor(i)}`}
            >
              {t}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
}
